import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#fbc02d',
    },
    secondary: {
      main: '#ffab00',
    },
  },
});
